import type { Address } from '../models';
import type { PhoneNumber } from './person';

export interface Relative {
    first_name: string;
    last_name: string;
    name: string;
    age: string;
}

export interface Exposed {
    first_name: string;
    middle_name?: string;
    last_name: string;
    aka: string[];
    date_of_birth: string;
    age: string;
    addresses: Address[];
    emails: string[];
    phones: string[];
    relatives: Relative[];
    url: string;
}

export interface CompanyChannel {
    id: number;
    name: string;

}

export interface CompanyParent {
    id: number;
    name: string;
    slug: string;
}

export interface CompanyType {
    value: string;
    label: string;
}

export enum ScannerStatus {
    ACTIVE = 'active',
    MAINTENANCE = 'maintenance',
    NONE = 'none',
}

export interface Company {
    id: number;
    name: string;
    url: string;
    logo: string;
    slug: string;
    trust_score: number;
    phone_numbers: PhoneNumber[];
    addresses: Address[];
    type: CompanyType;
    description: string;
    score: number;
    parent: CompanyParent;
    privacy_policy?: string;
    scanner: ScannerStatus;
    deletion_required_fields?: string[] | null;
}

// V3 API response structure
export interface PublicCompany {
    id: number;
    name: string;
    status: string;
    url: string;
    logo: string;
    slug: string;
    type: CompanyType;
    description: string;
}

export interface CompanyAdvisory {
    id: string;
    title: string;
    html: string;
    url: string;
    type: string;
    created_at: string;
    updated_at: string;
}

export interface DeletionGuideResponse {
    guide: string;
}

export enum CompanyTypeEnum {
    PEOPLE_SEARCH = 'people_search',
    PEOPLE_SEARCH_AFFILIATE = 'people_search_affiliate',
    DATA_BROKER = 'data_broker',
    ADVERTISING_MARKETING = 'advertising_marketing',
    JOB_RECRUITING = 'job_recruiting',
    BACKGROUND_CHECK = 'background_check',
    DATA_ENRICHMENT = 'data_enrichment',
    HEALTHCARE_INSURANCE = 'healthcare_insurance',
    GEOLOCATION = 'geolocation',
    SURVEILLANCE_TECH = 'surveillance_tech',
    WORK_INCOME_VERIFICATION = 'work_income_verification',
    INDUSTRY_OPTOUT = 'industry_optout'
}

export const COMPANY_TYPE_LABELS: Record<CompanyTypeEnum, string> = {
    [CompanyTypeEnum.PEOPLE_SEARCH]: 'People Search Site',
    [CompanyTypeEnum.PEOPLE_SEARCH_AFFILIATE]: 'People Search Site Affiliate',
    [CompanyTypeEnum.DATA_BROKER]: 'List Broker',
    [CompanyTypeEnum.ADVERTISING_MARKETING]: 'AdTech & Marketing',
    [CompanyTypeEnum.JOB_RECRUITING]: 'Job Recruiting',
    [CompanyTypeEnum.BACKGROUND_CHECK]: 'Background Check',
    [CompanyTypeEnum.DATA_ENRICHMENT]: 'Data Enrichment',
    [CompanyTypeEnum.HEALTHCARE_INSURANCE]: 'Healthcare & Insurance',
    [CompanyTypeEnum.GEOLOCATION]: 'Geo Location',
    [CompanyTypeEnum.SURVEILLANCE_TECH]: 'Surveillance Tech',
    [CompanyTypeEnum.WORK_INCOME_VERIFICATION]: 'Work & Income Verification',
    [CompanyTypeEnum.INDUSTRY_OPTOUT]: 'Industry Opt-Out'
};
